// extracted by mini-css-extract-plugin
export var bubble = "styles-module--bubble--9a263";
export var bubbleMarketing = "styles-module--bubbleMarketing--d0873";
export var buttonSupport = "styles-module--buttonSupport--65706";
export var buttonsWrapper = "styles-module--buttonsWrapper--a6605";
export var cardDesc = "styles-module--cardDesc--e0dc6";
export var cardMarker = "styles-module--cardMarker--dfc4c";
export var cards = "styles-module--cards--2777c";
export var chat = "styles-module--chat--3dd53";
export var dialogCards = "styles-module--dialogCards--44052";
export var dialogMarker = "styles-module--dialogMarker--92043";
export var hero = "styles-module--hero--6fb14";
export var heroHighlight = "styles-module--heroHighlight--4d385";
export var highlightForm = "styles-module--highlightForm--30a4d";
export var highlightScroll = "styles-module--highlightScroll--d983c";
export var marketingButton = "styles-module--marketingButton--589fe";
export var marketingDesc = "styles-module--marketingDesc--a2731";
export var marketingHighlight = "styles-module--marketingHighlight--40c42";
export var marketingTitle = "styles-module--marketingTitle--b0dc2";
export var salesHighlight = "styles-module--salesHighlight--3f232";
export var salesSection = "styles-module--salesSection--35e81";
export var salesSubtitle = "styles-module--salesSubtitle--d7725";
export var salesTitle = "styles-module--salesTitle--17318";
export var security = "styles-module--security--442d3";
export var securityContent = "styles-module--securityContent--5fa24";
export var securityWrapper = "styles-module--securityWrapper--79426";
export var startButton = "styles-module--startButton--28c0a";
export var startHighlight = "styles-module--startHighlight--a8912";
export var startStep = "styles-module--startStep--b4645";
export var startTitle = "styles-module--startTitle--b0f76";
export var supportHighlight = "styles-module--supportHighlight--9a414";
export var supportHighlightMarker = "styles-module--supportHighlightMarker--eb12f";
export var supportSubtitle = "styles-module--supportSubtitle--cd96a";
export var supportTitle = "styles-module--supportTitle--3da8a";